import * as React from "react";

import "./branded-footer.scss";

import {modifyWhiteElement} from "@Xpresso/routes/brand/branded-login/branded-login";


export const BrandedFooter = ({themeScheme}) => {
    const invert = modifyWhiteElement(themeScheme?.xpresso?.menuBackgroundColor)

    return (
        <footer
            className="footer-br4"
            style={{
                backgroundColor: themeScheme?.xpresso?.menuBackgroundColor,
                color: themeScheme?.xpresso?.menuTextColor
            }}
        >
            <div className="info">
                <div className="logo">
                    {
                        themeScheme?.xpresso?.headerLogo &&
                            <img src={themeScheme?.xpresso?.headerLogo} alt="footer-logo" xd-qa-type="image" xd-qa-name="Footer Logo"/>
                    }
                </div>
                <div className="about">
                    <h6 xd-qa-type="label" xd-qa-name="About">ABOUT</h6>
                    <p xd-qa-type="text" xd-qa-name="About Text">{textAbout}</p>
                    <a
                        href={"http://xpressdocs.com/marketing-materials"}
                        target="_blank"
                        style={{
                            color: themeScheme?.xpresso?.menuTextColor
                        }}
                        xd-qa-type="link"
                        xd-qa-name="Learn More"
                    >
                        Learn More
                    </a>
                </div>
                <div className="extras">
                    {resources({themeScheme})}
                    {contact({themeScheme})}
                </div>
            </div>
            <div
                className="line"
                style={{
                    backgroundColor: themeScheme?.xpresso?.menuTextColor
                }}
            >
            </div>
            {subFooter(invert)}
        </footer>
    )
}

const resources = ({themeScheme}) => {
    const listItems = [
        {
            name: "blog",
            href: "http://blog.xpressdocs.com/",
            text: "Xpressdocs Blog"
        },
        {
            name: "subscribe",
            href: "http://www.xpressdocs.com/subscribe/enews-signup.php",
            text: "Subscribe to Xpressions newsletter"
        }
    ]

    return (
        <div className="resources">
            <h6 xd-qa-type="label" xd-qa-name="Resources">RESOURCES</h6>
            {
                listItems.map((listItem, i) => (
                    <li key={listItem.name}>
                        <a
                            href={listItem.href}
                            target="_blank"
                            style={{
                                color: themeScheme?.xpresso?.menuTextColor
                            }}
                            xd-qa-type="link"
                            xd-qa-name={listItem.text}
                        >
                            {listItem.text}
                        </a>
                    </li>
                ))
            }
        </div>
    )
}

const contact = ({themeScheme}) => {

    return (
        <div className="contact">
            <h6 xd-qa-type="label" xd-qa-name="Contact">CONTACT</h6>
            <li
                style={{
                    color: themeScheme?.xpresso?.menuTextColor
                }}
                xd-qa-type="link"
                xd-qa-name="Phone Number"
            >
                866.977.3627
            </li>
            <li>
                <a
                    href="mailto:info@expressdocs.com"
                    target="_blank"
                    style={{
                        color: themeScheme?.xpresso?.menuTextColor
                    }}
                    xd-qa-type="link"
                    xd-qa-name="email"
                >
                    Info@xpressdocs.com
                </a>
            </li>
        </div>
    )
}

const subFooter = (invert) => {
    const socialLinks = [
        {
            name: "Facebook",
            href: "https://www.facebook.com/XDMarketing",
            icon: "https://assets.xpressdocs.com/images/_imgs/icons/flat_social/Facebook.png"
        },
        {
            name: "Twitter",
            href: "http://twitter.com/#!/XDMarketing",
            icon: "https://assets.xpressdocs.com/images/_imgs/icons/flat_social/Twitter.png"
        },
        {
            name: "Youtube",
            href: "http://www.youtube.com/XDMarketing",
            icon: "https://assets.xpressdocs.com/images/_imgs/icons/flat_social/YouTube.png"
        },
        {
            name: "Linkedin",
            href: "https://www.linkedin.com/company/xpressdocs",
            icon: "https://assets.xpressdocs.com/images/_imgs/icons/flat_social/LinkedIn.png"
        }
    ]
    return (
        <div className="sub-footer">
            <div className="social-links">
                {
                    socialLinks.map(socialLink => (
                        <a
                            key={socialLink.name}
                            className={`social-link ${invert ? 'invert' : ''}`}
                            href={socialLink.href}
                            target="_blank"
                            xd-qa-type="link"
                            xd-qa-name={socialLink.name}
                        >
                            <img src={socialLink.icon} alt={socialLink.name} xd-qa-type="image" xd-qa-name={socialLink.name}/>
                        </a>
                    ))
                }
            </div>
        </div>
    )
}

const textAbout = `The Xpressdocs Platform powers marketing management and compliance needs for many of the country's
    most recognized brands. Our technology is complimented by a broad range of production and distribution capabilities
    from conventional and digital printing, to engraving and complex variable data campaigns. We also offer digital
    marketing solutions including email, social and mobile marketing tools.`